import { ReactElement } from 'react';
import { Box, Typography, Card, CardContent, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';

interface StatItem {
  key: string;
  value: string | number;
  color?: 'primary' | 'secondary' | 'inherit';
  isLoading?: boolean;
}

interface StatisticsDisplayProps {
  stats: StatItem[];
}

export default function StatisticsDisplay({ stats }: StatisticsDisplayProps): ReactElement {
  return (
    <Box sx={{ m: 1 }}>
      <Grid container spacing={2}>
        {stats.map((stat, index) => (
          <Grid size={{ xs: 6, sm: 3 }} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardContent
                sx={{
                  p: 1.5,
                  '&:last-child': { pb: 1.5 },
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Typography variant="subtitle1" component="div">
                  {stat.key}
                </Typography>
                {stat.isLoading ? (
                  <CircularProgress size={20} />
                ) : (
                  <Typography variant="subtitle1" color={stat.color || 'primary'}>
                    {typeof stat.value === 'number' ? stat.value.toLocaleString() : stat.value}
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
export type { StatItem, StatisticsDisplayProps };
